import React from 'react';
import './ModalStyles.css';

const TableLoadingWrapper = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="loading-table-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading data...</p>
        </div>
      </div>
    );
  }
  return children;
};

export default TableLoadingWrapper;
